module.exports = __webpack_public_path__ + "img/hundred-years-capsules-placeholder.77cd964.jpg";